var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row items-center justify-end"},[_c('inertia-link',{attrs:{"href":_vm.campaignResource.url}},[_c('base-button',{attrs:{"label":"مشاهده","outline":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }